var TotalJobsGroup = TotalJobsGroup || {};
TotalJobsGroup.Header = TotalJobsGroup.Header || {};

TotalJobsGroup.Header.RedirectUrlUpdater = (function ($, location) {

	var _location = location || { pathname: "", search: "" };
	var _signinSelector = "a.signin-link";
	var _signoutSelector = "a.signout-link";

	function updateLinkQuerystrings(rootElement) {

		var signinElements = rootElement.find(_signinSelector);
		var signoutElements = rootElement.find(_signoutSelector);
		var allElements = $.merge(signinElements, signoutElements);

		$.each(allElements, function (index, element) {
			var href = $(element).attr("href");
			href += (/\?/.test(href) ? "&" : "?") + "ReturnUrl=" + getReturnUrl();
			$(element).attr("href", href);
		});
	}

	function setLocation(location) {
		_location = location;
	}

	function getReturnUrl() {
		var result = "";
		if ($.isNullOrUndefined(_location.pathname) === false) {
			result = _location.pathname;
		}

		// Ignore /Authenticated/ urls, redirect to the homepage.
		if ((/\/Authenticated\//i).test(result)) {
			return "/";
		}

		// Ignore /account/signin url, redirect to the homepage.
		if ((/\/account\/signin/i).test(result)) {
			return "/";
		}

		var querystring = _location.search;
		if (querystring !== null) {
			result += encodeURIComponent(querystring);
		}

		return result;
	}

	function init() {
		$(document).ready(function () {
			updateLinkQuerystrings($("div.navigation"));
			updateLinkQuerystrings($("footer"));
		});
	}

	try {
		init();
	}
	catch (e) {
	}

	return {
		init: init,
		setLocation: setLocation,
		updateLinkQuerystrings: updateLinkQuerystrings
	}
}(jQuery, window.location));